export function growthStatsSwiper() {
    const swiperContainers = document.querySelectorAll('.growth-stats__grid.swiper');
    if (!swiperContainers.length || typeof Swiper === 'undefined') {
        return;
    }

    // Keep track of multiple swiper instances by container element
    const swiperInstances = new Map();

    // Helper to initialize/destroy swipers based on viewport width
    const updateSwipers = () => {
        swiperContainers.forEach((container) => {
            const prevButton = container.querySelector('.growth-stats__arrow--prev');
            const nextButton = container.querySelector('.growth-stats__arrow--next');

            if (window.innerWidth <= 768) {
                if (!swiperInstances.get(container)) {
                    const swiperInstance = new Swiper(container, {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        loop: false,
                        speed: 300,
                        navigation: {
                            nextEl: nextButton,
                            prevEl: prevButton,
                        },
                    });
                    swiperInstances.set(container, swiperInstance);
                }
            } else {
                const existing = swiperInstances.get(container);
                if (existing) {
                    existing.destroy(true, true);
                    swiperInstances.delete(container);
                }
            }
        });
    };

    // Initialize on load
    updateSwipers();

    // Re-initialize on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateSwipers, 150);
    });
}
